export async function getHealth(): Promise<void> {
	const response = await fetch("/actuator/health/ping", {
		cache: "no-store"
	});
	if (!response.ok) {
		throw new Error(response.statusText);
	}
}
